export default class facebookCAPIApi {

    constructor(axios) {
        this.axios = axios
    }

    purchase(orderId, secret, apiEventId){
      return this.axios.post('/facebook-capi/purchase/' + orderId + '/' + secret + '/' + apiEventId)
    }

    pageView(companyId, eventId, apiEventId, pageUrl, pageTitle){
      return this.axios.post('/facebook-capi/pageview/' + companyId + '/' + eventId + '/' + apiEventId + '/' + encodeURIComponent(pageUrl) + '/' + encodeURIComponent(pageTitle))
    }

}
